import { VBtn } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import { throttle } from '@/libs/functions_utils'
import { formattingNumber } from '@/libs/util.js'
import styles from '../../index.module.less'
import mixIns from '../../mixIns.jsx'
import ChartContain from './ChartContain'
import {arrTohash} from '../../utils'
import { getGroupFinanceBalanceMonthlyLedgerQueryyApi } from '../../service'
import { illegalityData } from '../../utils'
import { createUsdRmbCharts, createZXCharts, createhdsyCharts } from '../utils'
// import {VBtn, Icon} from 'vuetify/lib'
export default {
    mixins: [mixIns],
    props: {
        header: {
            type: Array,
            default:() => []
        },
        unit: {
            type: Number,
            default: () => 1
        },
        params: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            records: [],
            record_hash: {},
            get_loading: false,
            chart_data_hash: {
                total_arr: [], // 资金余额变动
                exchange_gain_or_loss_arr: [], // 汇兑损益，
                usd_rmb: { // 美元人民币占比
                    usd: [],
                    rmb: []
                }
            }
        }
    },
    computed: {
        window_width() {
            return this.$store.state.window_width
        },
        records_c() {
            return this.records.filter(item => item.show)
        },
        assembly_headers() {
            const _this = this
            return [
                {
                    text: '',
                    align: 'center',
                    value: 'title',
                    fixed: 'left',
                    z_index: 8,
                    width: 250,
                    render:(...params) => {
                        return this.titleRemder(...params, _this)
                    }
                }
            ].concat(this.header.map(item => {
                return {
                    text: item,
                    align: 'end',
                    value:item,
                    width: 200,
                    render:(val, target) => {
                        const color = Number(val) < 0 ? 'red' : ''
                        const unit = this.params.unit
                        // illegalityData
                        //formattingNumber
                        if (target.not_data_show) {
                            return 
                        }   
                        if (illegalityData(val)) {
                            return <span>-</span>
                        }
                        if (target.val === 'is_checked') {
                            return <span>{val ? '已对账' : '未对账'}</span>
                        }
                        if (target.val === "parities") {
                            return <span>{formattingNumber(val, 4, 100)}</span>
                        }
                        return <span style={{color}}>{formattingNumber(val / unit, 2)}</span>
                    }
                }
            }))
        }
    },
    watch:{
        window_width() {
            this.throttleWidth && this.throttleWidth()
        },
        'params.unit'() {
            this.throttleWidth && this.throttleWidth()
        }
    },
    created() {
        // 截流处理
        this.throttleWidth = throttle.call(this, this.changeWidth, 500)
    },
    mounted() {
        this.throttleWidth()
        eventHub.$on('menu-resize', this.throttleWidth);
       
    },
    destroyed() {
        eventHub.$off('menu-resize', this.throttleWidth);
      },
    methods: {
        handleChartData(record_hash) {
            record_hash = record_hash || {}
            // 总金额
            const total_arr = []
            const total_hash = record_hash.total || {}
            // 净流入流出
            const net_cash_outflow_arr = []
            const net_cash_outflow_hash = record_hash.net_cash_outflow || {}
            //汇兑损益
            const exchange_gain_or_loss_arr = []
            const exchange_gain_or_loss_hash = record_hash.exchange_gain_or_loss || {}
            // 汇率
            const parities_hash = record_hash.parities || {}
            // 美元
            const usd_arr = [] // 美元/人民币占比
            const usd_internal_hash = record_hash.internal_usd || {}
            const usd_external_hash = record_hash.external_usd || {}
            // 人民币
            const rmb_arr = []
            const rmb_hash = record_hash.internal_rmb || {}
            this.header.forEach(i => {
                total_arr.push(total_hash[i]) // 
                net_cash_outflow_arr.push(net_cash_outflow_hash[i])
                exchange_gain_or_loss_arr.push(exchange_gain_or_loss_hash[i])
                
                const usd = math.eval(`(${usd_internal_hash[i] || 0}+${usd_external_hash[i] || 0})*${parities_hash[i]}/100`).toFixed(2)
                usd_arr.push(usd)
                rmb_arr.push(rmb_hash[i])
            })
            this.chart_data_hash = {
                total_arr, // 资金余额变动
                exchange_gain_or_loss_arr, // 汇兑损益，
                usd_rmb: { // 美元人民币占比
                    usd:usd_arr,
                    rmb:rmb_arr
                },
                net_cash_outflow_arr
            }
        },
        getDataProxy() {
            this.getTableData()
        },
        getTableData() {
            this.get_loading = true
            getGroupFinanceBalanceMonthlyLedgerQueryyApi({
                begin_month: this.params.begin_month,
                end_month: this.params.end_month,
            }).then(res => {
                this.setRecords(res || [])
            }).catch(() => {
                this.setRecords([])
            }).finally(() => {
                this.get_loading = false
            })
        },
        changeWidth({
            unit = this.params.unit,

        } = {}) {
            const window_width = this.$refs.charts_contain && this.$refs.charts_contain.offsetWidth - 10 || 0
            const ref_arr = [1, 2, 3, 4]
            const x_labels = this.header.map(i => i.slice(-5))
            const hash = {
                1: this.chart_data_hash.total_arr,
                2: this.chart_data_hash.exchange_gain_or_loss_arr,
                3: this.chart_data_hash.usd_rmb,
                4: this.chart_data_hash.net_cash_outflow_arr
            }
            ref_arr.forEach(i => {
                switch (i) {
                    case 1:
                        this.$refs[`${i}`] && this.$refs[`${i}`].changeSize({
                            width:window_width / 2.01, 
                            unit,
                            x_labels,
                            values: hash[i],
                            color: 'rgb(63, 149, 194)',
                            seriesName:'资金余额',
                            title:'资金余额变动情况',
                            generateDataCall:createZXCharts
                        })
                        break
                    case 2:
                        this.$refs[`${i}`] && this.$refs[`${i}`].changeSize({
                            width:window_width / 2.01, 
                            unit,
                            x_labels,
                            values: hash[i],
                            color:  'rgb(255, 201, 166)',
                            seriesName:'未实现汇兑损益',
                            title:'未实现汇兑损益变动情况',
                            generateDataCall:createhdsyCharts
                        })
                    break;
                    case 3:
                        this.$refs[`${i}`] && this.$refs[`${i}`].changeSize({
                            width:window_width / 2.01, 
                            unit,
                            x_labels,
                            values_hash: hash[i],
                            color: ['#69C0FF', '#B7EB8F'],
                            title: '美元/人民币占比',
                            generateDataCall:createUsdRmbCharts
                        })
                    break
                    case 4:
                        this.$refs[`${i}`] && this.$refs[`${i}`].changeSize({
                            width:window_width / 2.01, 
                            unit,
                            x_labels,
                            values: hash[i],
                            color:  'rgb(255, 201, 166)',
                            seriesName:'现金净流出/流入',
                            title:'现金净流出/流入变动情况',
                            generateDataCall:createhdsyCharts
                        })
                    break;
                    default:
                        break;
                }

           })
        },
        titleRemder(t, target = {}) {
            const _this = this
            return <div 
                        class={target.style}
                    >
                    {target.has_click && <VBtn 
                        x-small
                        text
                        on-click={() => {
                            target.is_open = !target.is_open
                            if (target.children) {
                                target.children.forEach(key => {
                                    _this.record_hash[key].show = target.is_open
                                })
                            }
                        }}
                    >
                        <Icon type={target.is_open ? 'ios-arrow-down' : 'ios-arrow-forward'}/>
                    </VBtn>} {t}
                </div>
        },
        setRecords(arr = []) {
           const hash = arrTohash(arr, ['id', 'month'])
           let init_data = this.gk()
           console.log('init_data', init_data)
           if (this.records && this.records.length) {
                init_data = this.records.map((item, index) => {
                    return Object.keys(init_data[index]).reduce((total, key) => {
                        total[key] = item[key]
                        return total
                    }, {})
                })
            }
           const exchange_rate_hash = arr.reduce((total, item) => {
            total[item.month] = item.rmb_usd_exchange_rate
            return total
           }, {})
           // 获取汇率
           
           // tab 切换时保持状态
           if (this.records && this.records.length) {
            init_data = this.records.map((item, index) => {
             
                if (!init_data[index]) {
                    return init_data[index]
                }
                return Object.keys(init_data[index]).reduce((total, key) => {
                    total[key] = item[key]
                    return total
                }, {})
            })
        }
           init_data = init_data.map(obj => {
            
              if (obj.val === 'parities') {
                return {
                    ...obj,
                    ...exchange_rate_hash
                }
              }
               if (!hash[obj.val]) {
                return obj
               }
               return {
                   ...obj,
                   ...hash[obj.val],
               }
           })
            const records = []
            const record_hash = {}
            init_data.forEach((item) => {
                records.push(item)
                record_hash[item.val] = item
            });
            this.records = records
            this.record_hash = record_hash
            this.throttleWidth()
            this.handleChartData(this.record_hash)
        }
    },
    render() {
        return <div class={styles['general']}>
            <VTable
               class={styles['table-header']}
               ref="table"
               loading={this.get_loading}
               no-data-text="暂无数据"
               headers={this.assembly_headers}
               desserts={this.records_c}
               rowClass={({value}) => {
                   return value.tr_style || ''
               }}
            />
            <div ref="charts_contain" class={styles['cahrt-contain']}>
               <ChartContain 
                ref="1"/>
               <ChartContain
                ref="2"/>
                 <ChartContain ref="3"/>
                 <ChartContain ref="4"/>
            </div>
            {/* <div class={styles['cahrt-contain']}>
               <ChartContain ref="3"/>
            </div> */}
        </div>
    }
}